import $ from 'jquery';

// var IS_DEVELOPMENT = false;
var win = $(window);

function ZoomTwo(elRoot) {
	this.elems = {};
	this.elems.root = $(elRoot);
	this.elems.zoomer = this.elems.root.find('.zoomtwo-item-zoomer');
	// this.elems.zoomerSquare = this.elems.zoomer.find('.zoomtwo-item-zoomer-square');
	this.elems.zoomerImage = this.elems.zoomer.find('.zoomtwo-item-zoomer-image');

	this.zoomer = {
		// square: {
		// 	width: 200,
		// 	height: 200,
		// },
		image: {
			width: 0,
			height: 0,
		},
	};

	this.item = {
		x: 0,
		y: 0,
		width: 0,
		height: 0,
	};

	win.on('resize', () => this.calculate());
	
	this.calculate();
	this.render();
	this.bindZoomer();
	this.elems.zoomer.hide();
}

ZoomTwo.prototype.render = function() {
	//
};

ZoomTwo.prototype.calculate = function() {
	let pos = this.elems.root.offset();
	// console.log('pos = ', pos);
	this.item.x = pos.left;
	this.item.y = pos.top;
	this.item.width = this.elems.root.width();
	this.item.height = parseInt(this.elems.root.css('padding-top').replace('px', ''));
	// console.log('height: ', this.item.height);
	this.zoomer.image.width = this.item.width * 2;
	this.zoomer.image.height = this.item.height * 2;
	// console.log('-> wh ', this.item.width, this.item.height);
	this.elems.zoomerImage.css({
		'width': this.zoomer.image.width + 'px',
		'height': this.zoomer.image.height + 'px',
	});
};

ZoomTwo.prototype.bindZoomer = function() {
	let isHover = false;
	let isTapped = false;
	// @ START OVER
	this.elems.root.hover(() => {
		// MouseOver
		if(!window.IS_TAP_ENABLED) {
			isHover = true;
			this.calculate();
			this.elems.zoomer.show();
		}
	}, () => {
		// MouseOut
		isHover = false;
		isTapped = false;
		this.elems.zoomer.hide();
	});
	this.elems.zoomer.on('mousemove', (e) => {
		// console.log('mousemove');
		if(!window.IS_TAP_ENABLED) {
			// MouseMove
			if(!isHover) return;
			let mouseX = Math.round(e.pageX - this.item.x - 1);
			let mouseY = Math.round(e.pageY - this.item.y - 1);
			// console.log('move ', mouseX, mouseY);
			// let midX = this.zoomer.square.width / 2;
			// let midY = this.zoomer.square.height / 2;
			// this.elems.zoomerSquare.css({
			// 	left: mouseX - midX,
			// 	top: mouseY - midY,
			// });
			// // this.zoomer.image.size
			let percX = parseInt(mouseX * 100 / this.item.width);
			let percY = parseInt(mouseY * 100 / this.item.height);
			console.log('perc: ', percX, percY, this.zoomer.image.width / 100, this.zoomer.image.width / 100 * percX);
			this.elems.zoomerImage.css({
				left: (this.zoomer.image.width / 100 * percX * -1) + (this.item.width / 2),
				top: (this.zoomer.image.height / 100 * percY * -1) + (this.item.height / 2),
			});
			// this.elems.zoomerImage.css({
			// 	left: (this.zoomer.image.width / 100 * percX * -1) + midX,
			// 	top: (this.zoomer.image.height / 100 * percY * -1) - (midY / 2),
			// });
		}
	});
	// @ END OVER

	// @ START TAP
	// HammerJS
	let hamRoot = new Hammer.Manager(this.elems.root[0]);
	hamRoot.add(new Hammer.Tap({event: 'doubletap', taps: 2}));
	hamRoot.add(new Hammer.Tap({event: 'singletap'}));
	hamRoot.get('doubletap').recognizeWith('singletap');
	hamRoot.get('singletap').requireFailure('doubletap');
	// hamRoot.on('doubletap', ev => {
	hamRoot.on('singletap', ev => {
		// console.log('doubletap!!');
		this.calculate();
		isTapped = !isTapped;
		if(isTapped) {
			this.elems.zoomer.show();
		} else {
			this.elems.zoomer.hide();
		}
	});
	let hCoords = {
		imgX: 0,
		imgY: 0,
		mouseX: 0,
		mouseY: 0,
		minX: this.elems.zoomerImage.width() * -1 + this.item.width,
		minY: this.elems.zoomerImage.height() * -1 + this.item.height,
	};
	let hamImage = new Hammer(this.elems.zoomer[0]);
	hamImage.get('pan').set({direction: Hammer.DIRECTION_ALL});
	hamImage.on('panstart', ev => {
		// Salvar coordenadas
		if(!isTapped) return;
		hCoords.imgX = parseInt(this.elems.zoomerImage.css('left').replace('px', ''));
		hCoords.imgY = parseInt(this.elems.zoomerImage.css('top').replace('px', ''));
		hCoords.mouseX = ev.center.x;
		hCoords.mouseY = ev.center.y;
		// console.log('pann::: ', hCoords);
	});
	hamImage.on('panleft panright panup pandown', ev => {
		// console.log('ev::: ', ev);
		if(!isTapped) return;
		let mouseX = ev.center.x;
		let mouseY = ev.center.y;
		let diffX = hCoords.mouseX - mouseX;
		let diffY = hCoords.mouseY - mouseY;
		let moveX = hCoords.imgX - diffX;
		let moveY = hCoords.imgY - diffY;
		console.log('moves: ', moveY, hCoords.minY);
		if(moveX > 0) moveX = 0;
		if(moveY > 0) moveY = 0;
		if(moveX < hCoords.minX) moveX = hCoords.minX;
		if(moveY < hCoords.minY) moveY = hCoords.minY;
		this.elems.zoomerImage.css({
			left: moveX,
			top: moveY,
		});
	});
	// @ END TAP
};

// export default ZoomTwo;


export default function(_IS_DEVELOPMENT) {
	// IS_DEVELOPMENT = _IS_DEVELOPMENT;
	
	$(document).ready(function() {
		$('[data-zoomtwo]').each(function() {
			new ZoomTwo(this);
		});
	});
};
